import { useEffect, useState } from 'react';
import axios from '../services/axios.service';

/** Independent report lifecycle, including retries and protection against stale responses. */
export function useReport(url) {
  const [revision, setRevision] = useState(0);
  const [result, setResult] = useState(null);
  const key = `${url}:${revision}`;
  useEffect(() => {
    if (!url) return undefined;
    let cancelled = false;
    axios.get(url).then(
      response => {
        if (!cancelled) setResult({ key, state: 'ready', data: response.data });
      },
      () => {
        if (!cancelled) setResult({ key, state: 'error', data: null });
      }
    );
    return () => {
      cancelled = true;
    };
  }, [url, key]);
  const current = result?.key === key ? result : { state: url ? 'loading' : 'idle', data: null };
  return { ...current, retry: () => setRevision(value => value + 1) };
}

export default function useDashboardReports(range) {
  const config = useReport('/api/analytics/config');
  const insights = useReport(`/api/analytics/insights?range=${range}&includeClarity=false`);
  const ga4 = useReport(config.data?.ga4MeasurementId ? `/api/analytics/ga4?range=${range}` : null);
  const clarity = useReport(config.data?.clarityProjectId ? '/api/analytics/clarity' : null);
  const rifas = useReport('/api/rifas/0/5');
  return { config, insights, ga4, clarity, rifas };
}
